import React from "react";
import Post from "./Post";
import ContentBelow from "../components/ContentBelow";

export default function PostList() {
  return (
    <div className="row">
      <Post />
    </div>
  );
}
